export enum FieldFlags {
    none,
    regex,
    path,
    byteSize,
    duration
}
